/**
 * Left column (3/4 width) of the single-patient eligibility details screen.
 */
import DiagnosisCard from "./diagnosis/DiagnosisCard";
import PatientHeader from "./header/PatientHeader";
import EligibilityTabs from "./tabs/EligibilityTabs";

/**
 * Header, diagnosis summary, and tabbed details for the eligibility screen.
 *
 * @returns Left column section
 */
const LeftPanel = () => {
  return (
    <div className="single-patient-eligibility-details__left flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-white">
      <PatientHeader />
      <div className="single-patient-eligibility-details__left-content flex min-h-0 flex-1 flex-col overflow-hidden p-4">
        <div className="single-patient-eligibility-details__left-content--cards-container">
          <DiagnosisCard />
        </div>
        <EligibilityTabs />
      </div>
    </div>
  );
};

export default LeftPanel;
